import * as constants from '../constants/location';
//import Locatable from '../classes/Locatable';

/** Location Actions */

/**
 * Sets the information of a given locatable
 *
 * @export
 * @param {Locatable} locatable Locatable to set
 * @returns
 */
export function setLocatable (locatable) {
    return {
        type: constants.SET_LOCATABLE,
        locatable
    }
}

/**
 * Removes a given locatable
 *
 * @export
 * @param {Locatable} locatable Locatable to remove
 * @returns
 */
export function removeLocatable (locatable) {
    return {
        type: constants.REMOVE_LOCATABLE,
        locatable
    }
}



// WEBPACK FOOTER //
// ./src/actions/location.js